import React, { useEffect, useState } from 'react';
import system from '../../system';
import { useGlobalStore } from './use-store';

/**
 * `useWidget` watches and returns the given widget model
 */
export function useWidget(type: string | undefined): null | typeof React.Component {
  const path = useGlobalStore((state) => (type && state.pkg[type]) || type, [type]);
  const [CodedComponent, setCodedComponent] = useState<any | null>(
    () => path && type && system.syncImport(path)?.[type],
  );

  // Setting the component in a use effect to avoid hydration errors.
  // This is because the component is not available in the server, and will only be available in the client.
  useEffect(() => {
    if (!CodedComponent && path && type) {
      const update = async () => {
        const Pkg = system.syncImport(path);
        const Component = Pkg?.[type];
        if (Component) setCodedComponent(() => Component);
      };

      update();
      return system.watch(path, update);
    }
  }, [CodedComponent, path]);

  return CodedComponent;
}
